import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { Save } from "react-feather";
import { FilePlus } from "react-feather";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//FORM
import CreateSubDeploymentForm from "./CreateSubDeploymentForm";

interface ModalProps {
  EmpNo: string;
}

const CreateSubDeploymentModal: React.FC<ModalProps> = ({ EmpNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Btn
          color="info"
          onClick={toggle}
          style={{ display: "flex", alignItems: "center", gap: "2px" }}
        >
          <FilePlus size={16} className="me-1" />
          Create Subs Deployment
        </Btn>
      </div>

      <Modal
        size="xl"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Create Sub Deployment</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Create a new employee sub deployment for this employee.{" "}
              <b style={{ color: "red" }}>
                Please review all information carefully before proceeding
              </b>
              .
            </P>
          </ModalHeader>
          <CreateSubDeploymentForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default CreateSubDeploymentModal;
